class CartShare extends HTMLElement {
  #copyButton;
  #copyLabel;
  #urlInput;
  #resetTimer;

  connectedCallback() {
    this.#copyButton = this.querySelector('[data-cart-share-copy]');
    this.#copyLabel = this.querySelector('[data-cart-share-copy-label]');
    this.#urlInput = this.querySelector('[data-cart-share-url]');

    this.#copyButton?.addEventListener('click', this.#handleCopy);
  }

  disconnectedCallback() {
    this.#copyButton?.removeEventListener('click', this.#handleCopy);
    clearTimeout(this.#resetTimer);
  }

  #handleCopy = async () => {
    const url = this.#urlInput?.dataset.cartShareUrl || this.#urlInput?.value;
    if (!url || !this.#copyLabel) return;

    const defaultLabel = this.#copyLabel.textContent;

    try {
      await navigator.clipboard.writeText(url);
    } catch {
      if (this.#urlInput instanceof HTMLInputElement) {
        this.#urlInput.select();
        document.execCommand('copy');
      }
    }

    this.#copyLabel.textContent = this.dataset.copiedLabel || 'Link copied';
    clearTimeout(this.#resetTimer);
    this.#resetTimer = setTimeout(() => {
      if (this.#copyLabel) this.#copyLabel.textContent = defaultLabel;
    }, 2000);
  };
}

if (!customElements.get('cart-share')) {
  customElements.define('cart-share', CartShare);
}
